export default "__VITE_ASSET__BwuHC84G__"